export const getBaseUrl = function () {
    if (process.env.NODE_ENV === 'development') {
        // return '//192.168.68.108:8080/api/v1'
        return '//localhost:8080/api/v1'
    } else {
        // return '//iskin.farmdroid.com:8443/api/v1'
        if (process.env.VUE_APP_PLATFORM === 'STAGE') {
            // dev backend on ECS/ALB (HTTPS:443, ACM cert) — was EC2 :8443
            return '//iskin-api.feelwonder.com/api/v1'
        } else {
            // prod backend on ECS/ALB (HTTPS:443, ACM cert) — was EC2 cms:8443
            return '//api.iskin.com.tw/api/v1'
        }
        // const host = location.host.split(':')[0]
        // return `${host}:8443/api/v1`
    }
}
export const baseURL = getBaseUrl()